export default __webpack_public_path__ + "static/media/YT-osadz.daf2d50a.webp";